import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import { COLORS } from '../../utils/Application_Constants';
import { TimesheetStatusEnumApi } from '../../components/ContentComponents/Timesheets/Status.enum';

const tableColumns = [
    { name: 'Clinician', key: 'name', size: 2, sortKey: 'clinicianLastName' },
    { name: 'Assignment/Location', key: 'location', size: 4, sortKey: 'location' },
    { name: 'Hours', key: 'hours', size: 1 },
    { name: 'Units', key: 'units', size: 1 },
    { name: 'Mileage', key: 'miles', size: 1 },
    { name: 'Status', key: 'status', size: 2, sortKey: 'status' },
    { name: 'Actions', key: 'actions', size: 1 },
];

const availableStatuses = [
    TimesheetStatusEnumApi.Approved,
    TimesheetStatusEnumApi.Rejected,
    TimesheetStatusEnumApi.Submitted,
    TimesheetStatusEnumApi.ReApproved,
    TimesheetStatusEnumApi.ReSubmitted,
];

const filters = ['Status', 'Week Ending'];

const actions = [
    {
        name: 'Approve',
        requestedStatus: TimesheetStatusEnumApi.Approved,
        icon: <DoneIcon fontSize="small" style={{ color: COLORS.LT_EMERALD }} />,
    },
    {
        name: 'Reject',
        requestedStatus: TimesheetStatusEnumApi.Rejected,
        icon: <ClearIcon fontSize="small" style={{ color: COLORS.LT_PEPPER }} />,
    },
    { name: 'View', requestedStatus: 'View', icon: <VisibilityIcon fontSize="small" /> },
];

const errorCodes = {
    '00013': 'Approved',
    '00014': 'Rejected',
    '00015': 'Recalled',
};

const getViewUrl = ({ clinicianId, id, locationId }) =>
    `/clinician/${clinicianId}/timesheet/${id}/review/${locationId}`;

export const config = {
    tableColumns,
    availableStatuses,
    actions,
    filters,
    errorCodes,
    getViewUrl,
};
